export default "__VITE_ASSET__DUgs$RuK__"